﻿import { useEffect, useMemo } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useCustomers } from '@/hooks/useCustomers';

interface Props {
  codazienda: string;
  value: string;
  onChange: (value: string) => void;
  tipologia?: string;
  className?: string;
}

const selectStyles = {
  control: (base: any) => ({ ...base, minHeight: 38, fontSize: 14, borderColor: '#ced4da' }),
  option: (base: any) => ({ ...base, fontSize: 13 }),
  placeholder: (base: any) => ({ ...base, fontSize: 13, color: '#94a3b8' }),
};

export default function CustomerSelect({ codazienda, value, onChange, tipologia, className }: Props) {
  const { t } = useTranslation();
  const { customers, fetchCustomers } = useCustomers();

  useEffect(() => {
    if (codazienda && codazienda !== '0') {
        fetchCustomers(codazienda, tipologia);
    }
  }, [codazienda, tipologia, fetchCustomers]);

  // Sort by ragsociale and build options
  const options = useMemo(() => {
    return [...customers]
      .sort((a, b) => (a.ragsociale || '').localeCompare(b.ragsociale || ''))
      .map(c => ({
        value: c.codcliente,
        label: c.codcliente + ' - ' + c.ragsociale,
      }));
  }, [customers]);

  const selected = useMemo(() => {
    if (!value || value === '0') return null;
    return options.find(o => o.value === value) || null;
  }, [value, options]);

  return (
    <Select
      options={options}
      value={selected}
      onChange={opt => {
        onChange(opt ? opt.value : '0');
      }}
      placeholder={t('selectCustomer')}
      isClearable
      isSearchable
      styles={selectStyles}
      noOptionsMessage={() => 'Nessun risultato'}
      className={className}
    />
  );
}

